import React from 'react';
import cx from 'classnames';
import { List } from '../List';
import {
  GLOBAL_NAMESPACE_PREFIX,
  ComponentClassnameActive,
  ComponentClassnameStatic,
  DropdownClassnameBase,
  DropdownClassnameContent,
} from '../../../tokens';

import styles from './Dropdown.less';

type ItemType = string;
type ItemsType = ItemType[];

export const DropdownClasses = {
  DROPDOWN: {
    BASE: `${GLOBAL_NAMESPACE_PREFIX}${DropdownClassnameBase}`,
    ACTIVE: `${GLOBAL_NAMESPACE_PREFIX}${DropdownClassnameBase}-${ComponentClassnameActive}`,
  },
  CONTENT: `${GLOBAL_NAMESPACE_PREFIX}${DropdownClassnameBase}-${DropdownClassnameContent}`,
  // For usage with static selects
  // includes styles for indicator
  STATIC: `${GLOBAL_NAMESPACE_PREFIX}${DropdownClassnameBase}--${ComponentClassnameStatic}`,
};

export interface DropdownProps {
  className?: string;
  style?: React.CSSProperties;
  /**
   * An array of objects that will be rendered as list items
   *
   * @default []
   **/
  items?: ItemsType;
  /**
   * The anchor to which the popover content is attached.
   */
  anchor?: string | JSX.Element;
}

export const Dropdown: React.FunctionComponent<DropdownProps> = (props) => {
  const { children, items = [], anchor, className, ...rest } = props;
  const dropdownClassName = cx(
    {
      [styles[DropdownClasses.DROPDOWN.BASE]]: true,
    },
    className,
  );

  return (
    <>
      {anchor && anchor}
      <div role="dialog" className={dropdownClassName} {...rest}>
        {items.length ? (
          <List items={items} />
        ) : (
          <div className={styles[DropdownClasses.CONTENT]}>{children}</div>
        )}
      </div>
    </>
  );
};
